export const featuredPortfolio = [
    {
        id: 1,
        title: "Web Design",
        img: "asset/web1.png",
        url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    },
    {
        id: 2,
        title: "Web Library",
        img: "asset/color.png",
        url: "https://chloehuang18.github.io/color-palette/"

    },
    {
        id: 3,
        title: "Data Structure",
        img: "asset/datastructure.png",
        url: "https://github.com/chloehuang18/Python-Data-Structure"

    },
    {
        id: 4,
        title: "Anki UI",
        img: "asset/anki.png",
        url: "https://www.figma.com/file/KcZzNUeyWc2axfThKQtzdD/Anki?node-id=0%3A1"

    }

]

export const webPortfolio = [
    {
        id: 1,
        title: "Print Certificate",
        img: "asset/web1.png",
        url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    },
    {
        id: 2,
        title: "Web Library",
        img: "asset/color.png",
        url: "https://chloehuang18.github.io/color-palette/"

    },
    // {
    //     id: 3,
    //     title: "Web Design",
    //     img: "asset/design.png",
    //     url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    // },
    // {
    //     id: 4,
    //     title: "Web Design",
    //     img: "asset/design.png",
    //     url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    // }

]

export const mobilePortfolio = [
    {
        id: 1,
        title: "Anki UI",
        img: "asset/anki.png",
        url: "https://www.figma.com/file/KcZzNUeyWc2axfThKQtzdD/Anki?node-id=0%3A1"

    },
    // {
    //     id: 2,
    //     title: "Web Design",
    //     img: "asset/design.png",
    //     url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    // },
    // {
    //     id: 3,
    //     title: "Web Design",
    //     img: "asset/design.png",
    //     url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    // },
    // {
    //     id: 4,
    //     title: "Web Design",
    //     img: "asset/design.png",
    //     url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    // }

]

export const dataPortfolio = [
    {
        id: 1,
        title: "Data Visualization",
        img: "asset/r.png",
        url: "https://github.com/chloehuang18/Data-visualization-with-R"

    },
    {
        id: 2,
        title: "Data Structure",
        img: "asset/datastructure.png",
        url: "https://github.com/chloehuang18/Python-Data-Structure"

    },
    // {
    //     id: 3,
    //     title: "Web Design",
    //     img: "asset/design.png",
    //     url: "https://chloehuang18.github.io/DavidOMcKayLibraryProfessionalCertification/"

    // }

]


